import posthog from 'posthog-js';

// Initialize PostHog
export const initPostHog = () => {
  if (typeof window !== 'undefined') {
    posthog.init('phc_h5VGblVOpuqtU5nFTBSeUyk5S1AaC6fdnUilUS0DIJ2', {
      api_host: 'https://app.posthog.com',
      autocapture: true,
      capture_pageview: true,
      capture_pageleave: true,
    });
  }
  return posthog;
};

export { posthog };
